/**
 * @ngdoc config
 * @name routeProviderConfig
 * @description
 * Sets the routes for the Campaign section:
 * - The default one (`/`).
 *
 * @param {Service} $routeProvider The interface for the Angular router.
 * @memberof campaign
 */
const routeProviderConfig = ($routeProvider) => {
  'ngInject';

  $routeProvider
  .when('/campaign/:id', {
    template: ({ id }) => `<campaign campaign-id="${id}"></campaign>`,
  });
};

export default routeProviderConfig;



// WEBPACK FOOTER //
// ./src/frontend/modules/campaign/configs/routeProvider.config.js